import { BaseTask } from "@jugl-web/rest-api/tasks";

export const isTaskFormBased = <
  TTask extends Pick<BaseTask, "order_resp" | "is_manual_order">,
>(
  task: TTask
): boolean => task.order_resp !== null && !task.is_manual_order;
